<template>
  <b-col lg="6" md="12" sm="12" class="mb-5">
    <b-card-header class="card-main-header">
        <h3 class="text-center">{{ plan.name }}</h3>
    </b-card-header>
    <b-card class="card-main p-3 shadow-sm">
      <h1 class="text-center display-4"><small class="dollar">$</small>{{ plan.amount }} <small class="text-muted">/ {{ plan.permanent == 0 ? 'mo' : 'life' }}</small></h1>

      <ul class="list-unstyled mt-5 mb-5">
        <li class="align-middle pb-3" v-for="perk in plan.perks" v-bind:key="perk.plan_id">
          <font-awesome-icon :icon="['fa', 'check']" size="1x" class="ml-3 mr-3 flat-text-green" />
          {{ perk.description }}
        </li>
      </ul>

      <a v-bind:href="'/donate/' + plan.plan_id" class="btn btn-lg btn-block btn-primary">Get Started</a>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props: ['plan'],
  data() {
    return {
    };
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/Index/Components/Plan.vue